import { render, staticRenderFns } from "./customPagination.vue?vue&type=template&id=4e728ee3&"
import script from "./customPagination.vue?vue&type=script&lang=js&"
export * from "./customPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports